export default {
  getSharepointSettings: 'integration/GET_SHAREPOINT_SETTINGS',
  getSharepointSettingsSuccess: 'integration/GET_SHAREPOINT_SETTINGS_SUCCESS',
  getSharepointSettingsFailure: 'integration/GET_SHAREPOINT_SETTINGS_FAILURE',

  syncSharepointRoot: 'integration/SYNC_SHAREPOINT_ROOT',
  syncSharepointRootSuccess: 'integration/SYNC_SHAREPOINT_ROOT_SUCCESS',
  syncSharepointRootFailure: 'integration/SYNC_SHAREPOINT_ROOT_FAILURE',
};
